import { render, staticRenderFns } from "./DocumentModal.vue?vue&type=template&id=8068b620&scoped=true&"
import script from "./DocumentModal.vue?vue&type=script&lang=ts&"
export * from "./DocumentModal.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentModal.vue?vue&type=style&index=0&id=8068b620&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8068b620",
  null
  
)

export default component.exports